import React, { useEffect, useState } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import {
  categoryAddEdit,
  categoryList,
} from "../../../../services/catagoryService";
import ImageUploader from "../../../form/ImageUploader";
import Radio from "../../../form/Radio";
import { toast } from "react-toastify";
import Select from "../../../form/Select";

const validation = {
  name: { required: true, message: "Category Name is required" },
};

const ManageCategory = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [image, setImage] = useState(null);
  const [isParent, setIsParent] = useState(true);
  const [parentCategories, setParentCategories] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: { name: "" },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({ name: data.name || "" });
      if (data.image?.url) setImage(data.image.url);
      if (typeof data.isParent === "boolean") setIsParent(data.isParent);
      if (data.isParent === false) setSelectedParent(data.parentId || null);
    }

    if (!data?._id || !data.isParent) fetchParentCategories();
  }, [data]);

  const fetchParentCategories = async () => {
    try {
      const response = await categoryList({ isParent: true, limit: 50 });
      const categories = response?.docs?.data;

      if (Array.isArray(categories)) {
        setParentCategories(
          categories.map((item) => ({ name: item?.name, value: item?._id }))
        );
      } else {
        console.error("Invalid category data format");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching parent categories");
    }
  };

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        image,
        ...(data?._id && { id: data._id }),
        isParent,
        ...(isParent === false && { parentId: selectedParent }),
      };
      return await categoryAddEdit(payload);
    },
    onSuccess: (res) => {
      toast.success(res?.message || "Category updated successfully!");
      getResponse(res);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  return (
    <form
      onSubmit={(event) => handleSubmit(event, mutate)}
      className="w-full max-w-4xl mx-auto p-6 bg-white shadow rounded space-y-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
        <ImageUploader
          isMultiple={false}
          isCrop={false}
          removeIcon={true}
          image={image}
          setImage={setImage}
          buttonLabel={image ? "Change Image" : "Upload Image"}
          inputClasses="w-24 h-24 rounded-full border overflow-hidden"
          buttonClasses="bg-blue-500 text-white text-xs px-3 py-1 rounded hover:bg-blue-600"
          buttonLabelClasses="text-xs"
        />
        <Input
          label="Category Name"
          inputPlaceholder="Enter Category Name"
          inputName="name"
          value={values?.name}
          onChange={handleChange}
          {...formValidate(errors, "name")}
        />
        <div className="flex flex-col items-start  gap-2 mt-4 md:mt-0">
          <label className="text-sm font-medium">Is Parent Category?</label>
          <div className="flex gap-4">
            <Radio
              radioName="isParent"
              radioLabel="Parent"
              value={true}
              isChecked={isParent === true}
              onChange={() => {
                setIsParent(true);
                setSelectedParent(null);
              }}
            />
            <Radio
              radioName="isParent"
              radioLabel="Sub Category"
              value={false}
              isChecked={isParent === false}
              onChange={() => {
                setIsParent(false);
                fetchParentCategories();
              }}
            />
          </div>
        </div>
      </div>
      {!isParent && parentCategories.length > 0 && (
        <div className="flex flex-col items-start w-full">
          <div className="md:w-1/2 w-full">
            <Select
              label="Select Parent Category"
              dropdownData={
                data?._id
                  ? parentCategories.filter((item) => item.value !== data._id)
                  : parentCategories
              }
              selectedValue={selectedParent}
              setSelectedValue={setSelectedParent}
              placeholder="Choose a parent category"
              required={true}
            />
          </div>
        </div>
      )}
      <div className="flex justify-center gap-4">
        <Button
          buttonType="submit"
          buttonLabel="Save"
          buttonClasses="px-6 py-2 rounded-full border border-green-600 text-green-600 hover:bg-green-600 hover:text-white"
          {...(isLoading && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
        <Button
          buttonLabel="Cancel"
          buttonClasses="px-6 py-2 rounded-full border border-gray-400 text-gray-600 hover:bg-gray-200"
          buttonFunction={close}
        />
      </div>
    </form>
  );
};

export default ManageCategory;
